import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";

interface Citation {
  kbTitle: string;
  kbDescription?: string;
  snippet: string;
  relevance: number;
}

interface CitationListProps {
  citations: Citation[];
}

export const CitationList = ({ citations }: CitationListProps) => {
  if (!citations || citations.length === 0) return null;

  return (
    <Card className="mt-2 p-3 bg-muted/50">
      <div className="text-sm font-medium mb-2 flex items-center gap-2">
        <span>📚 Sources</span>
        <Badge variant="secondary" className="text-xs">{citations.length}</Badge>
      </div>
      <div className="space-y-2">
        {citations.map((citation, idx) => (
          <div key={idx} className="text-xs space-y-1">
            <div className="flex items-center justify-between">
              <span className="font-medium">{citation.kbTitle}</span>
              <Badge variant="outline" className="text-xs">
                {citation.relevance}% match
              </Badge>
            </div>
            <p className="text-muted-foreground line-clamp-2">{citation.snippet}</p>
          </div>
        ))}
      </div>
    </Card>
  );
};
